// extracted by mini-css-extract-plugin
export default {"container":"styles_container__dSYPi","checkText":"styles_checkText__egkng","errorMessage":"styles_errorMessage__DVPrH","errorWrapper":"styles_errorWrapper__aZD8E"};